import { createContext, useContext } from 'react'

export type TaskTrackerPendingAttachmentFile = {
  blobUrl: string
  file: File
  fileName: string
}

export type TaskTrackerRichTextEditorProps = {
  value: string
  onChange?: (html: string) => void
  placeholder?: string
  disabled?: boolean
  /** Компактный вид без растягивания на всю высоту (например, ячейка таблицы). */
  compact?: boolean
  /**
   * Кнопки/paste картинок и файлов. По умолчанию true (как в drawer TT).
   * false — только текст/форматирование (например, шаблон create_task).
   */
  allowAttachments?: boolean
  onFileReject?: (message: string) => void
}

export type TaskTrackerRichTextEditorHandle = {
  setHtml: (html: string) => void
  getHtml: () => string
  /** Вставить текст в позицию курсора (шаблоны автоматизации и т.п.). */
  insertText: (text: string) => void
  getImageWidths: () => string[]
  getEditorContainerWidth: () => number
  getPendingAttachmentFiles: () => TaskTrackerPendingAttachmentFile[]
  clearPendingAttachmentFiles: () => void
}

export const iconProps = {
  onPointerEnterCapture: undefined,
  onPointerLeaveCapture: undefined,
} as const

export const isEmptyHtml = (value: string) => {
  const normalized = value.trim()

  return (
    !normalized ||
    normalized === '<p></p>' ||
    normalized === '<p><br></p>' ||
    normalized === '<p><br class="ProseMirror-trailingBreak"></p>'
  )
}

export const isSameHtml = (left: string, right: string) => {
  const normalizedLeft = isEmptyHtml(left) ? '' : left.trim()
  const normalizedRight = isEmptyHtml(right) ? '' : right.trim()

  return normalizedLeft === normalizedRight
}

type TaskTrackerRichTextEditorContextValue = {
  interactionsDisabled: boolean
}

export const TaskTrackerRichTextEditorContext =
  createContext<TaskTrackerRichTextEditorContextValue>({
    interactionsDisabled: false,
  })

export const useTaskTrackerRichTextEditorContext = () =>
  useContext(TaskTrackerRichTextEditorContext)

